// frontend/src/components/UdemyCourseStatus.js
import React from 'react';

const UdemyCourseStatus = ({ course }) => {
  if (!course) {
    return (
      <div className="bg-white rounded-lg shadow-sm p-6 mb-6 text-center text-gray-600">
        Selecciona un curso para ver su estado.
      </div>
    );
  }

  const totalLectures = course.sections?.reduce((sum, section) => sum + (section.lectures?.length || 0), 0) || 0;
  const totalSections = course.sections?.length || 0;
  const completionPercentage = course.status === 'published' ? 100 : (totalLectures > 0 ? Math.min(100, (totalLectures / 10) * 10) : 0); // Simulación de progreso

  return (
    <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
      <h2 className="text-xl font-bold mb-4">Estado del curso: {course.title}</h2>
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center">
          <div className={`w-3 h-3 rounded-full mr-2 ${
            course.status === 'published' ? 'bg-green-500' : 'bg-yellow-500'
          }`}></div>
          <span>{course.status === 'published' ? 'Publicado' : 'Borrador'}</span>
        </div>
        <span className="text-sm text-gray-500">Última actualización: {course.lastUpdated}</span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <h3 className="font-medium text-gray-700 mb-2">Progreso del curso</h3>
          <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
            <div className="h-full bg-purple-600 rounded-full" style={{ width: `${completionPercentage}%` }}></div>
          </div>
          <div className="text-sm text-gray-500 mt-1">{completionPercentage}% completado</div>
        </div>
        <div>
          <h3 className="font-medium text-gray-700 mb-2">Secciones</h3>
          <div className="text-lg font-bold">{totalSections}</div>
        </div>
        <div>
          <h3 className="font-medium text-gray-700 mb-2">Clases</h3>
          <div className="text-lg font-bold">{totalLectures}</div>
        </div>
      </div>
    </div>
  );
};

export default UdemyCourseStatus;